import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-hamburger-menu',
  templateUrl: './hamburger-menu.component.html',
  styleUrls: ['./hamburger-menu.component.css']
})
export class HamburgerMenuComponent implements OnInit {
  display = false;
  displaySearch = true;
  search: string;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }
  toggleDisplay(): void {
    console.log('test');
    this.display = !this.display;
  }
  onclick() {
    const element = document.getElementById('openSidebarMenu') as HTMLInputElement;
    element.checked = false;
  }
  onSearch(): void {
    setTimeout(() => this.router.navigate(['/busqueda', this.search]), 2500);
  }

}
